import { useState } from 'react';

import useForm from '../../../hooks/useForm';

import { verifyCode, resendCode } from '../../../services/VerifiyCode';
import { useAppContext } from '../../../contexts/app';
import { useUserContext } from '../../../contexts/user';
import { useKeycloakContext } from '../../../contexts/keycloak/context';

const useVerificationCode = ({ userData, onClose }) => {
  const { logoutKeycloak } = useKeycloakContext();
  const { blockScreen, handleAlert } = useAppContext();
  const {
    userSession, setUserSession, handleLogout,
  } = useUserContext();
  const { formData, handleOnChangeCode, resetFormData } = useForm({
    ...userData,
    code: '',
  });

  const [openModal, setOpenModal] = useState(true);

  const handleConfirm = () => {
    blockScreen(true);
    const { userId, code } = formData;
    Promise.all([verifyCode({ userId, code })]).then((results) => {
      resetFormData();
      handleAlert('Account successfully verified!', 'success');
      setTimeout(() => {
        if (userSession.status) {
          setUserSession({
            ...userSession,
            status: results[0].status,
          });
          handleLogout();
        } else {
          window.location.href = '/#/';
        }
        setOpenModal(false);
        blockScreen(false);
      }, 1000);
    }).catch((error) => {
      handleAlert(error, 'error');
      blockScreen(false);
    });
  };

  const handleResend = async () => {
    blockScreen(true);

    const { userId } = formData;

    try {
      await resendCode({ userId, channel: 'EMAIL' });

      resetFormData();
      handleAlert('Verification code resended!', 'success');
    } catch (error) {
      handleAlert(error, 'error');
    } finally {
      blockScreen(false);
    }
  };

  const handleMobileResend = async () => {
    blockScreen(true);

    const { userId } = formData;

    try {
      await resendCode({ userId, channel: 'SMS' });

      resetFormData();
      handleAlert('Verification code resended!', 'success');
    } catch (error) {
      handleAlert(error, 'error');
    } finally {
      blockScreen(false);
    }
  };

  const handleCloseModal = async () => {
    setOpenModal(false);
    onClose();
    blockScreen(true);
    logoutKeycloak();
    blockScreen(false);
  };

  return {
    formData,
    openModal,
    handleResend,
    handleMobileResend,
    handleConfirm,
    handleCloseModal,
    handleOnChangeCode,
  };
};

export default useVerificationCode;
